<template>
  <h1 class="text-red-700">Home Vue Component! {{ store.message }}</h1>
</template>

<script setup lang="ts">
import { useStore } from '@/src/store';

const store = useStore();
</script>
